module.exports = __webpack_public_path__ + "2c6f59b4ceca625a41c0464a37d5611a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-24.png
// module id = 3101
// module chunks = 0